import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import { initializeFirebase } from "./util/pushNotification";

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
document.title = "Dubito";
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx